import { useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxiosClientsContextProvider } from 'shared/axios/axios-clients-provider';

import ReadResidentsChangeLogQuery from 'features/residents/models/read-residents-change-log-query';
import ReadResidentsChangeLogResponse from 'features/residents/models/read-residents-change-log-response';

const residentBaseUrl = '/api/v1/resident';

enum ResidentsChangeLogQueryPaths {
  ReadResidentsChangeLog = 'ReadResidentsChangeLog',
}

const readResidentsChangeLog = async (
  axiosInstance: AxiosInstance,
  readResidentsChangeLogQuery: ReadResidentsChangeLogQuery,
): Promise<ReadResidentsChangeLogResponse> => {
  const response = await axiosInstance.post(
    `${residentBaseUrl}/${ResidentsChangeLogQueryPaths.ReadResidentsChangeLog}`,
    readResidentsChangeLogQuery,
  );
  return response.data;
};

export const useReadResidentsChangeLog = (readResidentsChangeLogQuery: ReadResidentsChangeLogQuery) => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useQuery({
    queryKey: [ResidentsChangeLogQueryPaths.ReadResidentsChangeLog, readResidentsChangeLogQuery],
    queryFn: () => readResidentsChangeLog(authenticatedInstance, readResidentsChangeLogQuery),
  });
};
